import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ReactionsCommentsQuery_comment: GraphQLTaggedNode = graphql`
	fragment ReactionsCommentsQuery_comment on Comment {
		id
		reactionsSummary(pageId: $containerId, contentType: "page", childType: "comment") {
			reactionsCount
			ari
			containerAri
			reactionsSummaryForEmoji {
				emojiId
				count
				reacted
				id
			}
		}
	}
`;

export const ReactionsCommentsQuery: GraphQLTaggedNode = graphql`
	query ReactionsCommentsQuery($contentId: ID!, $containerId: ID!) {
		comments(commentId: $contentId, contentStatus: [DRAFT, CURRENT]) {
			nodes {
				...ReactionsCommentsQuery_comment @relay(mask: false)
			}
		}
	}
`;
